import {
    Checkbox,
    Chip,
    Collapse,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material'
import config from '../../config.json'
import Link from '../common/util/input/Link'
import { isTemplateAssetSelectionInvalid } from '../editor/DropCreatorUtils'
import ImageElement from '../imageelement/ImageElement'
import { DropAlert } from './DropAlert'
import { DropButton } from './DropButton'
import { DropPaper } from './DropPaper'
import { SchemaSelectionElement } from './SchemaSelectionElement'

const AssetIdSelection = ({
    collectionName,
    checkedTemplateIds,
    template,
    checkedAssetIds,
    templateAssets,
    setCheckedAssetIds,
    maxClaimable,
    t,
    assetIdsToIgnore = [],
    assetsInThisPool,
}) => {
    return (
        <TableRow>
            <TableCell
                style={{
                    paddingBottom: 0,
                    paddingTop: 0,
                }}
                colSpan={7}
            >
                <Collapse in={checkedTemplateIds.has(template.id)}>
                    <div className="ml-10 mb-15">
                        <div className="my-5 text-lg">
                            Asset IDs of schema '{template.schema}' -{' '}
                            {template.id in checkedAssetIds &&
                            checkedAssetIds[template.id].size
                                ? checkedAssetIds[template.id].size
                                : 0}{' '}
                            assets selected
                            {assetsInThisPool?.length > 0
                                ? ', ' +
                                  templateAssets[template.id]?.filter((asset) =>
                                      assetsInThisPool.includes(asset.id),
                                  ).length +
                                  ' already in pool'
                                : null}
                        </div>
                        <div className="flex flex-wrap mb-5">
                            {templateAssets &&
                            templateAssets[template.id] &&
                            templateAssets[template.id].length > 0 ? (
                                templateAssets[template.id].map((asset) =>
                                    assetIdsToIgnore &&
                                    assetIdsToIgnore.length > 0 &&
                                    assetIdsToIgnore.includes(
                                        asset.id,
                                    ) ? null : (
                                        <div className="m-1 font-light">
                                            <Chip
                                                label={
                                                    parseInt(asset.mint) !== 0
                                                        ? '#' + asset.mint
                                                        : 'id: ' + asset.id
                                                }
                                                color={
                                                    assetsInThisPool.includes(
                                                        asset.id,
                                                    ) ||
                                                    (checkedAssetIds[
                                                        template.id
                                                    ] &&
                                                        checkedAssetIds[
                                                            template.id
                                                        ].has(asset.id))
                                                        ? 'primary'
                                                        : 'default'
                                                }
                                                disabled={assetsInThisPool.includes(
                                                    asset.id,
                                                )}
                                                onClick={() => {
                                                    if (
                                                        template.id in
                                                            checkedAssetIds &&
                                                        checkedAssetIds[
                                                            template.id
                                                        ].has(asset.id)
                                                    ) {
                                                        const tempSet = new Set(
                                                            checkedAssetIds[
                                                                template.id
                                                            ],
                                                        )
                                                        tempSet.delete(asset.id)
                                                        setCheckedAssetIds({
                                                            ...checkedAssetIds,
                                                            [template.id]:
                                                                tempSet,
                                                        })
                                                    } else if (
                                                        template.id in
                                                            checkedAssetIds &&
                                                        !checkedAssetIds[
                                                            template.id
                                                        ].has(asset.id)
                                                    ) {
                                                        const tempSet = new Set(
                                                            checkedAssetIds[
                                                                template.id
                                                            ],
                                                        )
                                                        tempSet.add(asset.id)
                                                        setCheckedAssetIds({
                                                            ...checkedAssetIds,
                                                            [template.id]:
                                                                tempSet,
                                                        })
                                                    } else if (
                                                        !(
                                                            template.id in
                                                            checkedAssetIds
                                                        )
                                                    ) {
                                                        setCheckedAssetIds({
                                                            ...checkedAssetIds,
                                                            [template.id]:
                                                                new Set([
                                                                    asset.id,
                                                                ]),
                                                        })
                                                    }
                                                }}
                                            />
                                        </div>
                                    ),
                                )
                            ) : (
                                <div className="my-auto">
                                    {t('editor.no_assets_available')}
                                </div>
                            )}
                            <div className={'m-1'}>
                                <Link
                                    href={`/creator/${collectionName}/nftcreator/${template.schema}/${template.id}`}
                                    external
                                >
                                    <Chip
                                        label="Mint more Assets to Contract..."
                                        clickable
                                    />
                                </Link>
                            </div>
                        </div>
                        <div className="mb-5 flex flex-wrap">
                            <DropButton
                                className="mx-2 my-auto"
                                disabled={
                                    !templateAssets ||
                                    !templateAssets[template.id]
                                }
                                onClick={() => {
                                    const tempAssetIds = []
                                    templateAssets[template.id]
                                        .filter(
                                            (asset) =>
                                                !assetIdsToIgnore.includes(
                                                    asset.id,
                                                ),
                                        )
                                        .map((asset) =>
                                            tempAssetIds.push(asset.id),
                                        )
                                    setCheckedAssetIds({
                                        ...checkedAssetIds,
                                        [template.id]: new Set(tempAssetIds),
                                    })
                                }}
                            >
                                Select All
                            </DropButton>

                            <DropButton
                                className="mx-2 my-auto"
                                disabled={
                                    !templateAssets ||
                                    !templateAssets[template.id]
                                }
                                onClick={() => {
                                    setCheckedAssetIds({
                                        ...checkedAssetIds,
                                        [template.id]: new Set([]),
                                    })
                                }}
                            >
                                Deselect All
                            </DropButton>

                            <DropButton
                                className="mx-2 my-auto"
                                onClick={() => {
                                    let tempAssetIds = []
                                    for (
                                        let i = 0;
                                        i <
                                        Math.min(
                                            parseInt(
                                                maxClaimable -
                                                    templateAssets[
                                                        template.id
                                                    ].filter((asset) =>
                                                        assetsInThisPool.includes(
                                                            asset.id,
                                                        ),
                                                    ).length,
                                            ),
                                            templateAssets[template.id].filter(
                                                (asset) =>
                                                    !assetIdsToIgnore.includes(
                                                        asset.id,
                                                    ),
                                            ).length,
                                        );
                                        i++
                                    ) {
                                        tempAssetIds.push(
                                            templateAssets[template.id].filter(
                                                (asset) =>
                                                    !assetIdsToIgnore.includes(
                                                        asset.id,
                                                    ),
                                            )[i].id,
                                        )
                                    }
                                    tempAssetIds = tempAssetIds.filter(
                                        (assetId) =>
                                            !assetsInThisPool.includes(assetId),
                                    )
                                    setCheckedAssetIds({
                                        ...checkedAssetIds,
                                        [template.id]: new Set(tempAssetIds),
                                    })
                                }}
                                disabled={
                                    !templateAssets ||
                                    !templateAssets[template.id] ||
                                    parseInt(maxClaimable) === 0 ||
                                    (parseInt(maxClaimable) > 0 &&
                                        templateAssets[template.id] &&
                                        parseInt(maxClaimable) >
                                            templateAssets[template.id].length)
                                }
                            >
                                Select Max Claimable #
                            </DropButton>
                        </div>
                    </div>
                </Collapse>
            </TableCell>
        </TableRow>
    )
}

export const DropSelectTemplatesEditor = ({
    collectionName,
    isAssetLevel,
    schemas,
    schemaTemplates,
    setSchemaTemplates,
    checkedTemplateIds,
    handleTemplateChecked,
    templateAssets,
    checkedAssetIds,
    setCheckedAssetIds,
    maxClaimable,
    t,
    ignoreRemainingCount = false,
    templateFilter = null,
    assetIdsToIgnore = [],
    assetsInThisPool,
}) => {
    return (
        <DropPaper
            expandable
            title="Select the Templates to be included in Your Drop"
            error={isTemplateAssetSelectionInvalid(
                t,
                isAssetLevel,
                checkedAssetIds,
                checkedTemplateIds,
                maxClaimable,
                assetsInThisPool,
                templateFilter,
            )}
            id="DropSelectTemplatesEditor"
        >
            <DropAlert
                condition={isAssetLevel && maxClaimable > 0}
                severity="warning"
                autoVerticalMargin={false}
                className="mb-5"
            >
                Please select <b>{maxClaimable}</b> assets per template
            </DropAlert>
            {schemas.map((schema) => (
                <SchemaSelectionElement
                    collectionName={collectionName}
                    schemaName={schema}
                    schemaTemplates={schemaTemplates}
                    setSchemaTemplates={setSchemaTemplates}
                    templateFilter={templateFilter}
                    key={'schema_' + schema}
                >
                    {!schemaTemplates[schema] ? (
                        <div className="italic">
                            No Templates present in schema {schema}
                        </div>
                    ) : (
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Rarity</TableCell>
                                        <TableCell align="center">
                                            Image
                                        </TableCell>
                                        <TableCell>
                                            Issued / Total Available
                                        </TableCell>
                                        <TableCell>Remaining</TableCell>
                                        <TableCell>Include in Drop?</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {schemaTemplates[schema] &&
                                        schemaTemplates[schema]
                                            .sort((a, b) => {
                                                return b.id - a.id
                                            })
                                            .map((template) => (
                                                <>
                                                    <TableRow>
                                                        <TableCell>
                                                            {template.id}
                                                        </TableCell>
                                                        <TableCell>
                                                            {template.name}
                                                        </TableCell>
                                                        <TableCell>
                                                            {template.rarity
                                                                ? template.rarity
                                                                : 'n/a'}
                                                        </TableCell>
                                                        <TableCell>
                                                            {template.image ||
                                                            template.video ? (
                                                                <ImageElement
                                                                    src={config.ipfspreviewhash
                                                                        .replaceAll(
                                                                            '{collection}',
                                                                            collectionName,
                                                                        )
                                                                        .replaceAll(
                                                                            '{hash}',
                                                                            template.video
                                                                                ? template.video
                                                                                : template.image,
                                                                        )
                                                                        .replaceAll(
                                                                            '{size}',
                                                                            '240',
                                                                        )}
                                                                    imgClassName="max-h-24 max-w-min"
                                                                />
                                                            ) : (
                                                                'n/a'
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            {
                                                                template.issuedSupply
                                                            }{' '}
                                                            /{' '}
                                                            {template.maxSupply ===
                                                            0
                                                                ? 'Infinite'
                                                                : template.maxSupply}
                                                        </TableCell>
                                                        <TableCell>
                                                            {template.maxSupply ===
                                                            0
                                                                ? 'Infinite'
                                                                : template.maxSupply -
                                                                  template.issuedSupply}
                                                        </TableCell>
                                                        <TableCell>
                                                            <Checkbox
                                                                disabled={
                                                                    !ignoreRemainingCount &&
                                                                    !isAssetLevel &&
                                                                    template.maxSupply >
                                                                        0 &&
                                                                    template.issuedSupply >=
                                                                        template.maxSupply
                                                                }
                                                                onChange={(
                                                                    e,
                                                                ) => {
                                                                    handleTemplateChecked(
                                                                        e,
                                                                        template.id,
                                                                        schema,
                                                                    )
                                                                }}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                    {isAssetLevel ? (
                                                        <AssetIdSelection
                                                            collectionName={
                                                                collectionName
                                                            }
                                                            checkedTemplateIds={
                                                                checkedTemplateIds
                                                            }
                                                            template={template}
                                                            checkedAssetIds={
                                                                checkedAssetIds
                                                            }
                                                            templateAssets={
                                                                templateAssets
                                                            }
                                                            setCheckedAssetIds={
                                                                setCheckedAssetIds
                                                            }
                                                            maxClaimable={
                                                                maxClaimable
                                                            }
                                                            t={t}
                                                            assetIdsToIgnore={
                                                                assetIdsToIgnore
                                                            }
                                                            assetsInThisPool={
                                                                assetsInThisPool
                                                            }
                                                        />
                                                    ) : null}
                                                </>
                                            ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </SchemaSelectionElement>
            ))}
            <DropAlert
                condition={
                    isTemplateAssetSelectionInvalid(
                        t,
                        isAssetLevel,
                        checkedAssetIds,
                        checkedTemplateIds,
                        maxClaimable,
                        assetsInThisPool,
                        templateFilter,
                    ) !== null
                }
                severity="error"
            >
                {isTemplateAssetSelectionInvalid(
                    t,
                    isAssetLevel,
                    checkedAssetIds,
                    checkedTemplateIds,
                    maxClaimable,
                    assetsInThisPool,
                    templateFilter,
                )}
            </DropAlert>
            <DropAlert
                condition={checkedTemplateIds.size > 0}
                severity="info"
                title="Selected Templates"
                autoVerticalMargin={false}
                className="mt-10 mb-5"
            >
                {Array.from(checkedTemplateIds).map((id) => (
                    <Link href={`/template/${id}`} external>
                        <span className="text-primary font-mono hover:underline">
                            {id}
                        </span>
                    </Link>
                ))}
            </DropAlert>
        </DropPaper>
    )
}
